import React, { useRef, useState } from 'react'
import Carousel from 'react-bootstrap/Carousel';
import emailjs from 'emailjs-com'

const Contact = () => {
    const form = useRef()

    const [data, updateData] = useState({
        Name: "",
        Email: '',
        Number: '',
        Subject: '',
        Message: ''
    })
    const { Name, Email, Number, Subject, Message } = data;

    const changeHandler = e => {
        updateData({ ...data, [e.target.name]: [e.target.value] })

    }
    const submitHandler = e => {
        e.preventDefault();

        emailjs.sendForm('service_d7nkc98', 'template_dhs0a87', e.target, '-_ajGXvF0DTOYDkQE')
            .then((result) => {
                alert("message Sent Succesfully")
                updateData({
                    Name: "",
                    Email: "",
                    Number: "",
                    Subject: '',
                    Message: ''

                })

            }, (error) => {
                console.log(error.text);
            });
    }
    return (
        <>
            <div id='Topmargin1' >
                <div className='about_banner'>
                    <img src='CONTACT US.png' className='about_image' alt=''></img>
                </div>
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-6'>
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d8398.096243313137!2d80.84394083272718!3d16.367281767360595!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a3601d97c629c13%3A0xc3cf3d754ef73554!2sPINNAMANENI%20MOTHER%20%26%20CHILD%20HOSPITAL%20FERTILITY%20CENTER!5e0!3m2!1sen!2sin!4v1756527730341!5m2!1sen!2sin" style={{ width: '100%', height: '450px', border: '0px' }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                    <div className='col-md-6' style={{ backgroundColor: '' }}>
                        <div >
                            <p style={{ fontSize: '5px !important', fontFamily: 'Roboto, sans-serif', color: '#722e85', marginBottom: '5px', textTransform: 'uppercase', marginTop: '40px',textAlign:'center',fontWeight:'bold'}}>GET IN TOUCH</p>

                            {/* form submission .......*/}
                            <form ref={form} onSubmit={submitHandler}>
                                <div className="container w-100 m-auto p-3 " style={{ borderRadius: '20px' }}  >
                                    <div className="row" >
                                        <div className="col-lg-6 my-3 ">
                                            <div className="form-group ">
                                                <input type="text" value={Name} onChange={changeHandler} className="form-control custom-input" title='' placeholder="Your Name" name="Name" required="Username is Required..." message="Username must be atmost 30 characters long..." style={{ padding: '10px', backgroundColor: '#722e85', border: 'none', borderBottom: '1px solid white' }} />
                                                <div className="help-block with-errors"></div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 my-3 ">
                                            <div className="form-group">
                                                <input type="email" value={Email} onChange={changeHandler} className="form-control custom-input" title='' placeholder="Your Email Address" name="Email" id="email" required="Email is required" data-error="Please enter your email" fdprocessedid="p2hd6j" style={{ padding: '10px', backgroundColor: '#722e85', border: 'none', borderBottom: '1px solid white' }} />
                                                <div className="help-block with-errors"></div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 my-3">
                                            <div className="form-group">
                                                <input type="text" value={Number} onChange={changeHandler} className="form-control custom-input" title='' name="Number" placeholder="Phone Number" id="phone_number" required="Number is Required" data-error="Please enter your number" fdprocessedid="cf7ig" style={{ padding: '10px', backgroundColor: '#722e85', border: 'none', borderBottom: '1px solid white' }} />
                                                <div className="help-block with-errors"></div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 my-3">
                                            <div className="form-group">
                                                <input type="text" value={Subject} onChange={changeHandler} className="form-control custom-input" title='' name="Subject" placeholder="Subject" id="msg_subject" required="Subject is Required" data-error="Please enter your subject" fdprocessedid="4mor3e" style={{ padding: '10px', backgroundColor: '#722e85', border: 'none', borderBottom: '1px solid white' }} />
                                                <div className="help-block with-errors"></div>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 my-3">
                                            <div className="form-group">
                                                <textarea name="Message" value={Message} onChange={changeHandler} className="form-control custom-input" id="message" cols="30" rows="4" placeholder="Type Your Message Here" required="Message is required" data-error="Write your message" style={{ backgroundColor: '#722e85', border: 'none', borderBottom: '1px solid white' }} ></textarea>
                                                <div className="help-block with-errors"></div>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12">
                                            <button type="submit" className="btn " title='' name="contact" style={{ backgroundColor: "#722e85", color: "white", border: '1px solid white' }} >Send Message</button>
                                            <div id="msgSubmit" className="h3 text-center hidden"></div>
                                            <div className="clearfix"></div>
                                        </div>
                                    </div>
                                </div>
                            </form>

                            {/* MAP....... */}

                        </div>
                    </div>
                </div>
            </div>
            <div className='container mt-4 mb-3'>
                <p style={{ fontSize: '5px !important', fontFamily: 'Roboto, sans-serif', color: '#722e85', marginBottom: '5px', textTransform: 'uppercase', marginTop: '40px',textAlign:'center',fontWeight:'bold'}}>Contact Information</p>
                <div className='row mt-4'>
                    <div className='col-md-4 mt-4 mb-2'>
                       <h5 style={{color:'grey',fontWeight:"bold",marginBottom:'5%'}}>Address : </h5>
                       <p style={{fontSize:'small',lineHeight:'4px'}}>Katuru Rd, Vuyyuru,</p>
                       <p style={{fontSize:'small',lineHeight:'4px'}}>Andhra Pradesh - 521165</p>
                    </div>
                    <div className='col-md-4 mt-4 mb-2'>
                        <h5 style={{color:'grey',fontWeight:"bold",marginBottom:'5%'}}>Phone : </h5>
                        <p style={{fontSize:'small',lineHeight:'4px'}}>+91 9441246269</p>
                        <p style={{fontSize:'small',lineHeight:'4px'}}>086762 32040</p>
                    </div>
                    <div className='col-md-4 mt-4 mb-2'>
                        <h5 style={{color:'grey',fontWeight:"bold",marginBottom:'5%'}}>Email : </h5>
                        <p style={{fontSize:'small',lineHeight:'4px'}}>Contact@pinnamanenihospital.com</p>
                    </div>
                </div>
            </div>
        </>
    )

}

export default Contact